import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { RouterModule } from '@angular/router';
import { ReportsService } from '../../../services/report.service';
import { LoggedInUserService } from 'src/app/services/auth/logged-in-user-service';
import { ModelType } from '@shared/constants/model-type.enum';

interface User {
  roles: string[];
}

@Component({
  selector: 'app-cvx-navbar',
  imports: [CommonModule, MenubarModule, RouterModule],
  templateUrl: './cvx-navbar.component.html',
  styleUrl: './cvx-navbar.component.scss',
  standalone: true
})
export class CvxNavbarComponent {
  private reportsService = inject(ReportsService);
  private loggedInUserService = inject(LoggedInUserService); 
  public temp: MenuItemCommandEvent;

  protected navbarMenuItems = signal<MenuItem[] | undefined>([
    { "label": "reports", "link": "" ,"items": [
      { "label": "component decoder", "command": () => this.downloadComponentDecoder(ModelType.Automotive) },
      { "label": "component corrections examples", "command": () => this.downloadComponentCorrectionExamples(ModelType.Automotive) }
    ]},
    { "label": "home", "link": "/" },
    { "label": "help", "link": "/", }
  ]);

  constructor() {
    this.loggedInUserService.currentUser$.subscribe((data: User) => {
      if (data && data.roles) {
        const userRoles = data.roles
          .filter((role: string) => Object.keys(ModelType).filter(key => isNaN(Number(key))).includes(role))
          .map((role: string) => ModelType[role as keyof typeof ModelType]);

        this.navbarMenuItems.update(items => {
          const reportsMenu = items?.find(item => item.label === 'reports');
          if (reportsMenu) {
            const predictorUsageItems = [];
            if (userRoles.includes(ModelType.Automotive)) {
              predictorUsageItems.push({ "label": "predictor usage - automotive", "command": () => this.downloadPredictorUsageCSV(ModelType.Automotive) });
            }
            if (userRoles.includes(ModelType.Industrial)) {
              predictorUsageItems.push({ "label": "predictor usage - industrial", "command": () => this.downloadPredictorUsageCSV(ModelType.Industrial) });
            }
            reportsMenu.items = [
              ...predictorUsageItems,
              { "label": "component decoder", "command": () => this.downloadComponentDecoder(ModelType.Automotive) },
              { "label": "component corrections Examples", "command": () => this.downloadComponentCorrectionExamples(ModelType.Automotive) }
            ];
          }
          return items;
        });
      }
    });
  }

  ngOninit() { }

  downloadPredictorUsageCSV(modelType: ModelType) {
    this.reportsService.getPredictordownloadCSV(modelType).subscribe((response) => {
      const fileName = `PredictorUsage${new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(/[/, ]/g, '').replace(/:/g, '.')}.csv`;
      this.reportsService.downloadFile(response, fileName);
    });
  }   

  downloadComponentDecoder(modelType: ModelType) {
    this.reportsService.getComponentDecoder(modelType).subscribe((response) => {
      this.reportsService.downloadFile(response, 'ComponentDecoder.xlsx');
    });
  }

  downloadComponentCorrectionExamples(modelType: ModelType) {
    this.reportsService.getComponentCorrectionExamples(modelType).subscribe((response) => {
      this.reportsService.downloadFile(response, 'ComponentCorrectionExamples.docx');
    });
  }
}
